import { DashboardFigure } from "@components/Dashboards/shell";

type Props = {
  totalEmployeesAuthenticated?: number;
  prominent?: boolean;
};

export const ResourceGroupAuthenticatedUsersStat = ({
  totalEmployeesAuthenticated,
  prominent,
}: Props) => {
  return (
    <DashboardFigure
      prominent={prominent}
      label="Authenticated users"
      value={totalEmployeesAuthenticated?.toString() ?? "0"}
      detail="All time"
    />
  );
};